// src/components/ad-banner/ad-banner.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React2 from "react";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { AdBlockerAware } from "@shared-ui/retail-sponsored-content-ad-block-detect-wrapper";
// src/components/utils/index.ts
var AdTypeName = {
  display: "meso-display-ad"
};
var uuidv4 = function () {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
    return (
      // eslint-disable-next-line no-bitwise
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  });
};
var formatDisplayAdButton = function (formatText) {
  return {
    __typename: "AdTransparencyButton",
    primary: formatText("sponsoredContent.transparency.adButton.text"),
    accessibility: formatText("sponsoredContent.transparency.adButton.text"),
    disabled: false,
    icon: null,
    analyticsPayload: null
  };
};
var formatOverlaySkeleton = function (formatText) {
  return {
    __typename: "TransparencyOverlaySkeleton",
    title: formatText("sponsoredContent.transparency.overlaySkeleton.title"),
    error: {
      __typename: "TransparencyOverlayError",
      icon: {
        __typename: "Icon",
        id: "info",
        size: "medium"
      },
      description: formatText("sponsoredContent.transparency.overlaySkeleton.errorDescription"),
      button: {
        __typename: "UIPrimaryButton",
        primary: formatText("sponsoredContent.transparency.overlaySkeleton.retryButton.text")
      },
      allowedRetryAttempts: 3,
      exceededAttemptsMessage: formatText("sponsoredContent.transparency.overlaySkeleton.errorExceededAttemptsMessage")
    }
  };
};
var buildAdTransparencyFragment = function (formatText) {
  return {
    __typename: "AdTransparencyTrigger",
    adTransparencyId: uuidv4().toString(),
    adTransparencyButton: formatDisplayAdButton(formatText),
    adTransparencyOverlaySkeleton: formatOverlaySkeleton(formatText)
  };
};
// src/components/ad-banner/__private/ad-banner-transparency.tsx
import React from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { useLocalization } from "@shared-ui/localization-context";
import { Transparency, TransparencyTriggerType } from "@shared-ui/retail-sponsored-content-transparency";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var AdBannerTransparency = function (param) {
  var lineItemId = param.lineItemId;
  var formatText = useLocalization().formatText;
  var transparencyFragment = buildAdTransparencyFragment(formatText);
  return /* @__PURE__ */React.createElement(Experiment, {
    name: "EU_Ad_Transparency_Feature_Gate"
  }, /* @__PURE__ */React.createElement(ExperimentControl, null, /* @__PURE__ */React.createElement(Experiment, {
    name: "IAB_Ad_Badge"
  }, /* @__PURE__ */React.createElement(ExperimentControl, null), /* @__PURE__ */React.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React.createElement(UitkSpacing, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React.createElement(UitkText, {
    theme: "standard",
    size: 200
  }, formatText("sponsoredContent.transparency.adButton.text")))))), /* @__PURE__ */React.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement(Transparency, {
    type: TransparencyTriggerType.DISPLAY_AD,
    lineItemId: lineItemId,
    data: transparencyFragment
  })))));
};
// src/components/ad-banner/ad-banner.tsx
var AdBanner = function (param) {
  var type = param.type,
    uci = param.uci,
    displayAdRef = param.displayAdRef,
    className = param.className,
    adSwapEnabled = param.adSwapEnabled,
    isEnabled = param.isEnabled;
  var _React2_useState = _sliced_to_array(React2.useState(false), 2),
    slotRendered = _React2_useState[0],
    setSlotRendered = _React2_useState[1];
  var _React2_useState1 = _sliced_to_array(React2.useState(false), 2),
    slotMediaQueryEnabled = _React2_useState1[0],
    setSlotMediaQueryEnabled = _React2_useState1[1];
  var _React2_useState2 = _sliced_to_array(React2.useState(""), 2),
    lineItemId = _React2_useState2[0],
    setLineItemId = _React2_useState2[1];
  React2.useEffect(function () {
    var getSlotInMediaQuery = function (event) {
      var _event_detail = event.detail,
        slot = _event_detail.slot,
        enabled = _event_detail.enabled;
      if (slot !== uci) {
        return;
      }
      setSlotMediaQueryEnabled(enabled);
    };
    window.addEventListener("OnMediaQuery", getSlotInMediaQuery);
    return function () {
      window.removeEventListener("OnMediaQuery", getSlotInMediaQuery);
    };
  }, [uci]);
  React2.useEffect(function () {
    var displayAdEl = displayAdRef.current;
    var getAdData = function (event) {
      var detail = event.detail;
      if (detail.code !== "AD-LOAD-PASS") {
        setLineItemId("");
        setSlotRendered(false);
        return;
      }
      setSlotRendered(true);
      setLineItemId(detail.lineItemId);
    };
    if (displayAdEl) {
      displayAdEl.addEventListener("mesoAd", getAdData);
    }
    return function () {
      if (displayAdEl) {
        displayAdEl.removeEventListener("mesoAd", getAdData);
      }
    };
  }, [displayAdRef]);
  var displayAd = function (_type, _uci, _displayAdRef, _className) {
    var _adSwapEnabled = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false,
      _isEnabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    return React2.createElement(AdTypeName[_type || "display"], {
      uci: _uci,
      slot: _uci,
      ref: _displayAdRef,
      class: _className,
      adSwapEnabled: _adSwapEnabled ? true : null,
      enabled: _isEnabled ? true : null
    });
  };
  var adTransparency = function (_slotRendered, _slotMediaQueryEnabled, _lineItemId) {
    if (_slotRendered && _slotMediaQueryEnabled && _lineItemId) {
      return /* @__PURE__ */React2.createElement(AdBannerTransparency, {
        lineItemId: _lineItemId
      });
    }
    return null;
  };
  return /* @__PURE__ */React2.createElement(AdBlockerAware, {
    adBlockExperiment: "IAB_Acceptable_Ads_Enablement"
  }, /* @__PURE__ */React2.createElement(Experiment2, {
    name: "Split_View_Side_by_side_BEXG_H",
    logExposure: false
  }, /* @__PURE__ */React2.createElement(ExperimentControl2, null, displayAd(type, uci, displayAdRef, className), adTransparency(slotRendered, slotMediaQueryEnabled, lineItemId)), /* @__PURE__ */React2.createElement(ExperimentVariant2, {
    bucket: 1
  }, adTransparency(slotRendered, slotMediaQueryEnabled, lineItemId), displayAd(type, uci, displayAdRef, className, adSwapEnabled, isEnabled))));
};
AdBanner.displayName = "sharedui-AdBanner";
export { AdBanner };